export const OPEN_SUBSCRIPTION_MODAL = 'OPEN_SUBSCRIPTION_MODAL';

export const CLOSE_SUBSCRIPTION_MODAL = 'CLOSE_SUBSCRIPTION_MODAL';

export const OPEN_FORGOT_PASS_MODAL = 'OPEN_FORGOT_PASS_MODAL';

export const CLOSE_FORGOT_PASS_MODAL = 'CLOSE_FORGOT_PASS_MODAL'